import React from 'react';

// The Flex, Base360 and Flex Academy side by side, each card styled in that
// brand's own fonts and colors so the bridge between them reads at a glance.
const brands = [
  {
    id: 'flex',
    name: 'the flex.',
    description: 'The proof. Georgia headlines, Inter body.',
    swatches: ['#284E4C', '#D2DADA', '#FFF9E9', '#FFFDF6'],
  },
  {
    id: 'base360',
    name: 'base360',
    description: 'The platform. Roboto throughout, with 600 weight headlines.',
    swatches: ['#5070FE', '#080D1C', '#F8FAFD'],
  },
  {
    id: 'academy',
    name: 'Flex Academy',
    description: "The bridge. Roboto Serif headlines and Roboto body, with the feel of an operator's field guide.",
    swatches: ['#F6F1E6', '#1C302C', '#D9A35C'],
  },
];

function BrandComparison() {
  return (
    <div className="brand-comparison">
      {brands.map((brand) => (
        <div key={brand.id} className={`brand-card brand-card--${brand.id}`}>
          <ul className="brand-card__swatches">
            {brand.swatches.map((hex) => (
              <li key={hex}>
                <span className="swatch" style={{ backgroundColor: hex }} />
                <span className="swatch__hex">{hex}</span>
              </li>
            ))}
          </ul>
          <h4 className="brand-card__name">{brand.name}</h4>
          <p className="brand-card__body">{brand.description}</p>
        </div>
      ))}
    </div>
  );
}

export default BrandComparison;
